var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vx-page-title-actions',[_c('vx-button',{attrs:{"to":_vm.createBotRoute,"variant":"primary"}},[_vm._v(" Add ")])],1),_c('vx-table',{attrs:{"resource":_vm.resource,"columns":_vm.columns,"filters":_vm.filters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }